import { render, staticRenderFns } from "./apply_test.vue?vue&type=template&id=7143101c&scoped=true"
import script from "./apply_test.vue?vue&type=script&lang=js"
export * from "./apply_test.vue?vue&type=script&lang=js"
import style0 from "./apply_test.vue?vue&type=style&index=0&id=7143101c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7143101c",
  null
  
)

export default component.exports